import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CustomAutocomplete from 'Common/CustomAutocomplete';
import { loadAutocomplete, clearAutocomplete } from 'Actions/user';
import { QueryFilterType } from 'Types';

@connect(
    store => ({
        userFilter: store.userListAutocomplete.filter,
        usersData: store.userListAutocomplete.data,
    }),
    dispatch => ({
        loadAutocomplete: filter => dispatch(loadAutocomplete(filter)),
        clearAutocomplete: () => dispatch(clearAutocomplete()),
    })
)
export default class EmailAutocomplete extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        filter: PropTypes.object,
        usersData: PropTypes.array,
        userFilter: QueryFilterType.isRequired,
        loadAutocomplete: PropTypes.func.isRequired,
        clearAutocomplete: PropTypes.func.isRequired,
        value: PropTypes.any,
        initialValues: PropTypes.array,
        allowedUsers: PropTypes.array
    };

    static defaultProps = {
        filter: {}
    };

    state = {
        values: null
    };

    componentDidMount() {
        const { initialValues } = this.props;
        this.handleInputChange('');
        if (this.state.values === null) {
            this.setState({values: initialValues});
        }
    }

    componentWillReceiveProps(nextProps) {
        const { value } = nextProps;
        if (this.state.values === null && Array.isArray(value)) {
            this.handleChange(value);
        }
    }

    /**
     * Clear autocomplete data
     */
    componentWillUnmount(){
        const { clearAutocomplete } = this.props;
        clearAutocomplete();
    }

    /**
     * On change
     *
     * @param inputValue
     */
    handleInputChange = (inputValue) => {
        const { userFilter, loadAutocomplete, filter, allowedUsers } = this.props;
        const { values } = this.state;
        const nameFilter = [];
        inputValue.split(' ').forEach(namePart => nameFilter.push(
            { first_name: { like: `%${namePart}%` } }, { last_name: { like: `%${namePart}%` } }
        ));

        loadAutocomplete(
            userFilter
                .merge({ where: {
                    or: [{ email: { like: `%${inputValue}%` } }, { id: { inq: values } }]
                        .concat(nameFilter),
                }})
                .merge(allowedUsers ? { where: {id: {inq: allowedUsers}}} : {})
                .merge(filter, { deep: true }),
        );
    };

    handleChange = (values) => {
        this.setState({ values });
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { usersData, ...autocompleteProps } = this.props;
        return (
            <CustomAutocomplete
                {...autocompleteProps}
                options={[...usersData.map(item => ({
                    value: item.id,
                    label: item.name + ' (' + item.email + ')',
                }))]}
                customChange={this.handleChange}
                onInputChange={this.handleInputChange}
                isMulti
                value={this.state.values}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Autocomplete/EmailAutocomplete.jsx